import { UseRecordsOptions } from "../../api/useRecords";
//
export const categoriesParentOptions = {
  fieldsToRemove: {
    fieldTypesToRemove: ["alias"],
    fieldNamesToRemove: ["id"],
  },
  groupsOptions: {
    fieldsWithExtraOptions: [
      {
        field: "picture",
        fileFolder: "2790164e-62ad-40d9-b421-f4d7436bec54",
      },
      {
        field: "categories",
        enabled: true,
      },
    ],
  },
} as unknown as UseRecordsOptions;
